<div role="main" class="main">
	<section class="page-header page-header-modern bg-color-light-scale-1 page-header-md">
		<div class="container">
			<div class="row">
				<div class="col-md-12 align-self-center p-static order-2 text-center">
					<h1 class="text-dark font-weight-bold text-8">Intestech Blogları</h1>
				</div>

			</div>
		</div>
	</section>
	<div class="container py-4">
		<div class="row">
			<div class="col-lg-2 blogcategory" >
				<aside class="sidebar">

						<h5 class="font-weight-bold pt-4">Kategoriler</h5>
              <ul class="nav nav-list flex-column mb-5">
                <li class="nav-item" *ngFor="let item of categories" (click)="changeCategory(item.id)">
                  <a class="nav-link" [ngClass]="{'active': item.id==selectedCategory.id}"  style="cursor: pointer;">{{item.name}} ({{item.blogs.length}})</a>
                </li>
              </ul>

          </aside>
       </div>
          <div class="col-lg-3 blogcat"></div>
          <div class="col-lg-9" style="padding-top:1%">
            <div class="blog-posts">
              <article class="post post-medium" *ngFor="let blog of selectedCategory.blogs">
                <div class="row mb-3">
                  <div class="col-lg-7">
                    <div class="post-image">
                      <a [routerLink]="['/blog/', blog.postId]">
                        <img  [src]="apiurl+blog.photo"  class="img-fluid img-thumbnail img-thumbnail-no-borders rounded-0 mainimg" alt="" />
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div class="post-content">
                      <h2 class="font-weight-semibold pt-4 pt-lg-0 text-5 line-height-4 mb-2">
                        <a [routerLink]="['/blog/', blog.postId]">{{blog.title}}</a>
                      </h2>
                      <p class="mb-0">{{blog.shortDescription}} [...]</p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="post-meta" style="padding-left: 4%;padding-top: 2%;">
                      <span>
                        <i class="fa fa-calendar"></i> {{blog.dt | date:'dd.MM.yyyy'}}
                      </span>
                      <span>
                        <i class="fa fa-user"></i> Yazar
                        <a >{{blog.creator}}</a>
                      </span>
                      <span class="d-block d-sm-inline-block float-sm-right mt-3 mt-sm-0" style="float: right;">
                        <a [routerLink]="['/blog/', blog.postId]" class="btn btn-xs btn-light text-1 text-uppercase readmorebtn">Devamını Oku..</a>
                      </span>
                    </div>
                  </div>
                </div>
              </article>

            </div>
          </div>
        </div>
      </div>
    </div>
